import hasPermi from './hasPermi'

const install = function(Vue) {
  // Vue.directive('permission', permission)
  Vue.directive('hasPermi', hasPermi)
}

if (window.Vue) {
  // window['permission'] = permission
  window['hasPermi'] = hasPermi
  Vue.use(install); // eslint-disable-line
}

export default install
